import styled from "styled-components";

export const SubHeader = styled.div`
  width: 100%;
  height: 63px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const SubHeaderText = styled.div`
  width: auto;
  height: 22px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  letter-spacing: 0.03rem;
  p {
    font-size: 22px;
    font-family: "Akrobat";
    color: rgb(61, 61, 61);

    strong {
      font-family: "Akrobat ExtraBold";
    }
  }
`;
export const SubHeaderWithControl = styled.div`
  width: 100%;
  height: 22px;
  position: relative;
  margin-top: 10px;
`;
export const SubHeaderWithControlText = styled.div`
  width: 445px;
  height: 22px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  top: 3px;
  background-color: white;
  letter-spacing: 0.03rem;
  z-index: 1;

  p {
    font-size: 20px;
    font-family: "Akrobat";
    color: rgb(61, 61, 61);
    position: relative;
    float: left;
    top: 3px;
    left: 7px;
    strong {
      font-family: "Akrobat ExtraBold";
    }
  }
  h1 {
    margin-top: 0.2rem;
    width: 30px;
    height: 30px;
    font-size: 15px;
    border-radius: 15px;
    position: relative;
    float: left;
    font-family: "Akrobat SemiBold";
    display: flex;
    align-items: center;
    padding-left: 13px;
    color: white;
    background-color: #80bd01;
    margin-left: 0.6rem;
  }
  span {
    width: 40px;
    height: 10px;
    text-align: right;
    background-color: #d0d0d0;
  }
`;
export const SubHeaderWithControlLine = styled.div`
  width: 100%;
  height: 2px;
  position: absolute;
  top: 18px;
  background-color: rgba(61, 61, 61, 0.131);
`;
export const SubHeaderWithControlButton = styled.div`
  width: 90px;
  height: 25px;
  position: relative;
  float: right;
  display: flex;
  top: -15px;
  justify-content: center;
  background-color: white;
  margin-right: 15px;
  cursor: pointer;
  p {
    font-size: 18px;
    font-family: "Akrobat SemiBold";
    color: rgb(61, 61, 61);
    letter-spacing: 0.03rem;
    margin-left: 3px;
  }
`;
export const ButtonContinueContainer = styled.div`
  width: 95%;
  height: 65px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 25px;
  display: flex;
  left: 0px;
  justify-content: flex-end;
  align-items: center;
`;
export const ButtonContinueContainerContent = styled.div`
  width: 140px;
  height: 80px;
  display: flex;
  align-items: center;
  button {
    width: 140px;
    height: 50px;
    position: relative;
    border: none;
    border-radius: 4px;
    background-color: #ff7e00;
    font-size: 20px;
    font-family: "Akrobat ExtraBold";
    color: white;
    letter-spacing: 0.03rem;
    cursor: pointer;
  }
`;
export const HeaderScreenContainer = styled.div`
  width: 100%;
  height: 110px;
  background-color: #80bd01;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const HeaderScreenContainerContentTitle = styled.div`
  width: 200px;
  height: 22px;
  position: relative;
  margin-left: auto;
  margin-right: auto;

  h1 {
    font-size: 22px;
    font-family: "Akrobat ExtraBold";
    color: white;
  }
`;
export const InfoBudgetContainer = styled.div`
  width: 100%;
  height: 40px;
  background-color: #999999;
  border-radius: 3px;
  display: flex;
  align-items: center;
  
  button{
    position:absolute;
    float:right;
    margin-left:15px;
    font-family:'Akrobat SemiBold';
    color: white;
    text-shadow: 1px 0 0 red, -1px 0 0 red, 0 1px 0 red, 0 -1px 0 red, 0.5px 0.5px red, -0.5px -0.5px 0 red, 0.5px -0.5px 0 red, -0.5px 0.5px 0 red;
    text-decoration: underline;
  }

`;
export const InfoBudgetContainerContent = styled.div`
  height: 20px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  p {
    font-size: 20px;
    font-family: "Akrobat";
    color: white;
    margin-left: 20px;
    letter-spacing: 0.03rem;
    strong {
      font-family: "Akrobat ExtraBold";
    }
  }

`;
export const ContainerLoading = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  z-index: 999;
`;
export const ContainerLoadingContent = styled.div`
  width: auto;
  height: 120px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  img {
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
`;
export const CheckStepByStepContainer = styled.div`
  width: 100%;
  height: 60px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
`;
export const CheckStepByStepContainerBlocks = styled.div`
  width: 60%;
  height: 100%;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  // background-color: chocolate;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const CheckStepByStepContainerBlocksBlock = styled.div`
  width: 60px;
  height: 60px;
  position: relative;
  // background-color: green;
  display: flex;
  flex-direction: column;
`;
export const CheckStepByStepContainerBlocksBlockStep = styled.div`
  width: 60px;
  height: 60px;
  justify-content:center;
  background-color: #80bd01;
  border-radius: 40px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  transition: 0.3s;
  cursor: pointer;
  z-index: 1;
  .circlegray {
    background-color: #d0d0d0;
    width: 60px;
  height: 60px;
  border-radius: 40px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  transition: 0.3s;
  cursor: pointer;
  z-index: 1;
  }
  &:hover {
    transition: 0.3s;
    transform: scale(1.1, 1.1);
  }
  h1 {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    font-size: 40px;
    font-family: "Akrobat Semibold";
    color: white;
  }
`;
export const CheckStepByStepContainerContent = styled.div`
  width: 60%;
  height: 100%;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  // background-color: chocolate;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const CheckStepByStepContainerContentDivisor = styled.div`
  width: 90px;
  height: 5px;
  position: relative;
  top: 0px;
  background-color: #80bd01;
  .linegray {
    background-color: #d0d0d0;
    width: 90px;
    height: 5px;
    position: relative;
    top: 0px;
  }
`;

export const CheckStepByStepContainerBlocksSubtitle = styled(CheckStepByStepContainerBlocks)`
  width: 55%;
`;
export const CheckStepByStepContainerBlocksBlockSubtitle = styled(CheckStepByStepContainerBlocksBlock)`
  width: 20%;
`;
export const CheckStepByStepContainerBlocksBlockDescription = styled.div`
  width: 100%;
  height: 20px;
  position: relative;
  text-align: center;
  p {
    font-size: 20px;
    font-family: "Akrobat";
    color: rgb(61, 61, 61);
    text-align: center;
  }
`;
export const ButtonEditContainer = styled.div`
width: 95%;
height: 65px;
position: relative;
margin-left: auto;
margin-right: auto;
margin-top: 25px;
display: flex;
left:0px;
justify-content: flex-end;
align-items: center;
`;
export const ButtonEditContainerButton = styled.div`
width: 75px;
height: 80px;
display: flex;
align-items: center;
cursor:pointer;
button{
    width: 140px;
    height: 50px;
    position: relative;
    border: none;
    border-radius: 4px;
    background-color: #ff7e00;
    font-size: 20px;
    font-family: 'Akrobat ExtraBold';
    color: white;
    letter-spacing: 0.03rem;
    cursor: pointer;
}
`;
